import { ErrorBody, HTTPStatusCodes, ErrorCodes } from 'services/Request/error'

export const isUnavailableError = (error: ErrorBody) =>
  error.httpStatusCode === HTTPStatusCodes.InternalServerError ||
  error.httpStatusCode === HTTPStatusCodes.ServiceUnavailable ||
  error.code === ErrorCodes.System
